import Select from "react-select";

const SearchableDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  noOptionsMessage,
  optionRender,
  ...rest
}) => {
  return (
    <Select
      isSearchable
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      noOptionsMessage={() => noOptionsMessage || "No options"}
      formatOptionLabel={(option, meta) =>
        !!optionRender ? optionRender(option, meta) : option.label
      }
      className="searchable-dropdown"
      classNamePrefix="searchable-dropdown"
      {...rest}
    />
  );
};

export default SearchableDropdown;
